import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { PHONE_COUNTRIES, countrySearchText } from "../lib/internationalPhone";
import "./CountryCodeSelect.css";

export default function CountryCodeSelect({ value, onValueChange, label = "País e indicativo" }) {
  const [open, setOpen] = useState(false);
  const selected = PHONE_COUNTRIES.find(country => country.id === value) || PHONE_COUNTRIES[0];
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open}
          aria-label={`${label}: ${selected.name} ${selected.code}`}
          className="aorra-country-trigger">
          <span className="shrink-0" aria-hidden="true">{selected.flag}</span>
          <span className="min-w-0 flex-1 text-left leading-snug">{selected.name}</span>
          <span className="shrink-0 tabular-nums text-[#545454]">{selected.code}</span>
          <ChevronDown className="h-4 w-4 shrink-0 text-[#545454]" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={8} collisionPadding={16}
        className="aorra-country-popover p-0" aria-label="Seleccionar país e indicativo">
        <Command className="aorra-country-command" filter={(option, search) => countrySearchText(option).includes(countrySearchText(search)) ? 1 : 0}>
          <CommandInput placeholder="País o indicativo" aria-label="Buscar país o indicativo" />
          <CommandList className="aorra-country-list">
            <CommandEmpty>No encontramos ese país o indicativo.</CommandEmpty>
            <CommandGroup>
              {PHONE_COUNTRIES.map(country => (
                <CommandItem key={country.id} value={`${country.name} ${country.code} ${country.id}`}
                  className="aorra-country-option" data-current={country.id === value}
                  onSelect={() => { onValueChange(country.id); setOpen(false); }}>
                  <span aria-hidden="true">{country.flag}</span>
                  <span className="min-w-0 flex-1 break-words">{country.name}</span>
                  <span className="shrink-0 tabular-nums">{country.code}</span>
                  <span className="w-4 shrink-0">{country.id === value && <Check className="h-4 w-4" aria-hidden="true" />}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
